import {
    Component,
    Input,
    OnDestroy,
    OnInit
} from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";
import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-identificacion-personal-apoyo",
    templateUrl: "./identificacion-personal-apoyo.component.html",
    styleUrls: ["./identificacion-personal-apoyo.component.scss"],
})
export class IdentificacionPersonalApoyoComponent implements OnInit, OnDestroy {
    @Input() persona: PersonaDTO;

    subscripciones: Subscription;

    fotoPerfil: SafeUrl;
    
    constructor(
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _usuarioSrvc: UsuarioService,
        private sanitizer: DomSanitizer,
    ) {
        this.subscripciones = new Subscription();
    }

    ngAfterViewInit() {
        this.buscarFotoPerfil();
    }


    async buscarFotoPerfil(){      
        this._usuarioSrvc.fetchFoto(this.persona?.codigoFoto).subscribe(blob=>{
          let url = window.URL.createObjectURL(blob);  
          this.fotoPerfil=this.sanitizer.bypassSecurityTrustUrl(url);
        })
    }

    ngOnInit(): void {
        
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
